import { useCallback } from 'react'
import type { AuthConfig } from '../../types'

export const useGenerateGetAccessTokenAction = (config: AuthConfig) => {
  const { accessTokenRef } = config
  return useCallback(
    () => accessTokenRef?.current?.token || null,
    [accessTokenRef],
  )
}
